export const VerificationDataPageSubmission = 'VerificationDataPageSubmission/';
export const VerificationDataPageSubmissionSearch = VerificationDataPageSubmission + 'Search';
export const VerificationDataPageLockMetaForImport = VerificationDataPageSubmission + 'GetScorecardDataPageLockMetaForImport';
